import {
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	ListItemText,
	makeStyles,
	MenuItem,
	TextField,
	Typography
} from '@material-ui/core'

import Autocomplete from '@material-ui/lab/Autocomplete'
import clsx from 'clsx'
import React from 'react'
import { useSelector } from 'react-redux'

import { states } from '../../../services/helpers'

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridGap: '23px',
		gridTemplateColumns: '1fr 1fr 1fr',
		marginBottom: '50px'
	},
	gridDouble: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		gridTemplateColumns: '1fr 1fr',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				width: '100%'
			}
		}
	},
	fieldWrapper: {
		'& .MuiTextField-root': { width: '100%', minWidth: '100%' }
	},
	checkBox: {
		display: 'flex',
		flexDirection: 'row'
	},
	input: {
		display: 'none'
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	}
}))

const BasicInfo = (props) => {
	const classes = useStyles()
	let { selectedFacility, setCurrent } = props

	let yesNoOptions = ['Yes', 'No']
	let apartmentOptions = ['Apartment', 'Stand-Alone']

	const apartmentList = useSelector((state) => state.specific.facilities.apartmentList)

	const marketsLoading = useSelector((state) => state.specific.markets.loading)
	const markets = useSelector((state) => state.specific.markets.markets)

	const updateAddress = (field, value) => {
		let { address } = selectedFacility.contact
		let updated = { ...address }

		if (field == 'state') {
			value = value.id
		}

		updated[field] = value

		setCurrent({
			...selectedFacility,
			contact: {
				...selectedFacility.contact,
				address: updated
			}
		})
	}

	return (
		<Card style={{ maxWidth: '1245px' }}>
			<CardHeader title="Basic Info" />
			<CardContent>
				<div className={classes.gridDouble}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Facility Name"
							variant="filled"
							value={selectedFacility.name}
							disabled={!selectedFacility.active}
							onChange={(e) => setCurrent({ ...selectedFacility, name: e.target.value })}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							variant="filled"
							select
							value={
								markets && selectedFacility.market_id
									? markets.find((m) => m._id === selectedFacility.market_id)
									: ''
							}
							label="Market *"
							disabled={marketsLoading || !selectedFacility.active}
							onChange={(e) =>
								setCurrent({
									...selectedFacility,
									market_id: e.target.value._id
								})
							}>
							{markets && markets.length > 0 ? (
								markets.map((market) => (
									<MenuItem key={market._id} value={market}>
										{market.city}
									</MenuItem>
								))
							) : (
								<MenuItem>No Markets</MenuItem>
							)}
						</TextField>
					</div>
				</div>
				<div className={classes.grid}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							select
							label="Facility Type"
							variant="filled"
							value={selectedFacility.apartment ? 'Apartment' : 'Stand-Alone'}
							disabled={!selectedFacility.active}
							onChange={(e) => {
								let isApartment = e.target.value == 'Apartment' ? true : false
								setCurrent({
									...selectedFacility,
									apartment: isApartment
								})
							}}>
							{apartmentOptions.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<Autocomplete
							select
							size="small"
							id=""
							className={classes.autoComplete}
							options={apartmentList || []}
							value={
								apartmentList && selectedFacility.apartment_id
									? apartmentList.find((a) => a._id === selectedFacility.apartment_id).name
									: ''
							}
							onChange={(e, v) => {
								setCurrent({
									...selectedFacility,
									apartment_id: v._id
								})
							}}
							onClose={(e) => {
								e.target.value = ''
							}}
							disabled={!selectedFacility.apartment || !selectedFacility.active}
							renderOption={(option) => (
								<React.Fragment>
									<ListItemText style={{ textTransform: 'capitalize' }} primary={option.name} />
								</React.Fragment>
							)}
							renderInput={(params) => (
								<TextField {...params} variant="filled" fullWidth label="Apartment" />
							)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							select
							label="Apartment Restricted?"
							variant="filled"
							value={selectedFacility.apartment_restricted ? 'Yes' : 'No'}
							disabled={!selectedFacility.active || !selectedFacility.apartment}
							onChange={(e) => {
								let isApartmentRestricted = e.target.value == 'Yes' ? true : false
								setCurrent({
									...selectedFacility,
									apartment_restricted: isApartmentRestricted
								})
							}}>
							{yesNoOptions.map((option) => (
								<MenuItem key={option} value={option}>
									{option}
								</MenuItem>
							))}
						</TextField>
					</div>
				</div>
				<div className={classes.gridDouble}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Phone Number"
							variant="filled"
							value={selectedFacility.contact.phone_number}
							disabled={!selectedFacility.active}
							onChange={(e) =>
								setCurrent({
									...selectedFacility,
									contact: {
										...selectedFacility.contact,
										phone_number: e.target.value
									}
								})
							}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Email Address"
							variant="filled"
							value={selectedFacility.email}
							disabled={!selectedFacility.active}
							onChange={(e) => setCurrent({ ...selectedFacility, email: e.target.value })}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Street Address"
							variant="filled"
							value={selectedFacility.contact.address.address_line_1}
							disabled={!selectedFacility.active}
							onChange={(e) =>
								setCurrent({
									...selectedFacility,
									contact: {
										...selectedFacility.contact,
										address: {
											...selectedFacility.contact.address,
											address_line_1: e.target.value
										}
									}
								})
							}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="City"
							variant="filled"
							value={selectedFacility.contact.address.city}
							disabled={!selectedFacility.active}
							onChange={(e) =>
								setCurrent({
									...selectedFacility,
									contact: {
										...selectedFacility.contact,
										address: {
											...selectedFacility.contact.address,
											city: e.target.value
										}
									}
								})
							}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<Autocomplete
							size="small"
							getOptionLabel={(option) => option.name}
							id="Facility State"
							className={classes.autoComplete}
							options={states || []}
							disabled={!selectedFacility.active}
							value={
								selectedFacility.contact.address.state
									? states.find((s) => s.id == selectedFacility.contact.address.state)
									: ''
							}
							onChange={(e, v) => updateAddress('state', v)}
							onClose={(e) => {
								e.target.value = ''
							}}
							renderOption={(option) => (
								<React.Fragment>
									<ListItemText primary={option.name} />
								</React.Fragment>
							)}
							renderInput={(params) => <TextField {...params} variant="filled" label="State" />}
							onKeyPress={(e, v) => (e.key === 'Enter' ? updateAddress('state', v) : null)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Zip"
							variant="filled"
							value={selectedFacility.contact.address.zip_code}
							disabled={!selectedFacility.active}
							onChange={(e) =>
								setCurrent({
									...selectedFacility,
									contact: {
										...selectedFacility.contact,
										address: {
											...selectedFacility.contact.address,
											zip_code: e.target.value
										}
									}
								})
							}
						/>
					</div>
					<div className={classes.checkBox}>
						<Checkbox
							checked={selectedFacility.contact.address.override_geocode}
							onChange={(e, v) => updateAddress('override_geocode', v)}
						/>
						<Typography
							variant="body2"
							style={{
								display: 'flex',
								fontWeight: 600,
								justifyContent: 'center',
								alignItems: 'center'
							}}>
							Override Geocode
						</Typography>
					</div>
				</div>
				<div className={classes.gridDouble}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Latitude"
							variant="filled"
							value={selectedFacility.contact.address.loc.coordinates[1]}
							disabled={true}
							onChange={(e) => setCurrent({ ...selectedFacility, email: e.target.value })}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Longitude"
							variant="filled"
							value={selectedFacility.contact.address.loc.coordinates[0]}
							disabled={true}
							onChange={(e) => setCurrent({ ...selectedFacility, email: e.target.value })}
						/>
					</div>
				</div>
			</CardContent>
		</Card>
	)
}

export default BasicInfo
